var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCompareView = function SvgCompareView(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 22,
    viewBox: "0 0 21.6 19",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.5,
    height: 17.5,
    x: 0.75,
    y: 0.75,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 19,
    x: 11.6,
    fill: "currentColor",
    rx: 2.55
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCompareView);
export default ForwardRef;